/**
 * What a client has paid JTNC, from tbl_stripe_payment_history (Kajabi + Stripe rows, matched by email).
 * Test, trial, $1 affiliate and $0 rows are left out; Echo is a separate product and is listed apart.
 */

const NOT_A_PAYMENT = /test|\bQA\b|trial|affiliate/i;
const ECHO = /echo/i;

const round2 = (n) => Math.round(n * 100) / 100;

const dayOf = (v) => {
  if (!v) return '';
  if (typeof v.toDate === 'function') return v.toDate().toISOString().slice(0, 10);
  const d = new Date(v);
  return Number.isNaN(d.getTime()) ? '' : d.toISOString().slice(0, 10);
};

export const paymentKind = (row) => {
  const desc = String(row.subs_description || row.product_details || '');
  if (/deposit/i.test(desc)) return 'deposit';
  if (String(row.subs_interval_type || '').toLowerCase() === 'month') return 'monthly';
  return 'other';
};

/**
 * Only Stripe Pay As You Go rows (cus_ customer ids) are written per invoice. Kajabi rows (numeric ids)
 * and the Monthly Maintenance Fee hold the first charge only, so later months are missing.
 */
const renewalsRecorded = (row, description) =>
  String(row.customerId || '').startsWith('cus_') && /pay as you go/i.test(description);

export function clientPayments(rows) {
  const payments = [];
  const echo = [];
  for (const row of rows || []) {
    const amount = Number(row.amount);
    const description = String(row.subs_description || row.product_details || 'Payment');
    if (!(amount > 1) || NOT_A_PAYMENT.test(description)) continue;
    const p = {
      id: row.id,
      date: dayOf(row.subs_start_date) || dayOf(row.createdAt) || dayOf(row.created_at),
      amount: round2(amount),
      description,
      kind: paymentKind(row),
      renewalsMissing: paymentKind(row) === 'monthly' && !renewalsRecorded(row, description),
      stripeInvoice: renewalsRecorded(row, description),
    };
    (ECHO.test(description) ? echo : payments).push(p);
  }
  payments.sort((a, b) => a.date.localeCompare(b.date));
  const sum = (list) => round2(list.reduce((s, p) => s + p.amount, 0));
  // A Kajabi Pay As You Go start followed by Stripe invoices (Kajabi -> Stripe move) is not missing anything.
  const stripeInvoiced = payments.some((p) => p.stripeInvoice);
  return {
    payments,
    total: sum(payments),
    deposit: sum(payments.filter((p) => p.kind === 'deposit')),
    monthly: sum(payments.filter((p) => p.kind === 'monthly')),
    other: sum(payments.filter((p) => p.kind === 'other')),
    echo: sum(echo),
    renewalsMissing: payments.some(
      (p) => p.renewalsMissing && !(stripeInvoiced && /pay as you go/i.test(p.description))
    ),
  };
}
